import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import CheckMark from '@/assets/check.svg';
import FlexBox from '@/atomic-components/FlexBox';
import Link from 'next/link';
import { ListingUrlHelper } from '@/utils/seo-url-helper';
import { useFullScreenLoader } from '@/hooks/useFullScreenLoader';
import FullScreenLoader from '@/atomic-components/FullScreenLoader';
import { useEffect } from 'react';

export type CategoryData = {
	name: string;
	label: string;
	collectionType: string;
};

type CategoryTilesProps = {
	data: CategoryData;
	lineOfProduct?: string;
	selectedCategory: string | null;
	setSelectedCategory: (e: any) => void;
};

function CategoryTiles(props: CategoryTilesProps) {
	const { data } = props;

	const { loader } = useFullScreenLoader();

	const categorySelected = () => props.setSelectedCategory(data.name);

	const getBackgroundColor = () => {
		if (props.selectedCategory == data.name) {
			return data.collectionType == 'CATEGORY_RENT'
				? getColor('Orange 0')
				: getColor('Navy 0');
		} else {
			return getColor('');
		}
	};

	return (
		<Link
			href={`${ListingUrlHelper({
				collectionType: data.collectionType,
				name: data.name,
				lineOfProduct:
					props.lineOfProduct != 'BUY_ALL' ? props?.lineOfProduct : '',
			})}`}
		>
			<FlexBox
				// onClick={categorySelected}
				sx={{
					cursor: 'pointer',
					alignItems: 'center',
					padding: '14px 26px',
					borderRadius: '8px',
					margin: '0 8px',
					border:
						props.selectedCategory == data.name
							? 'none'
							: `1px solid ${getColor('Gray -2')}`,
					background: getBackgroundColor,
				}}
			>
				{props.selectedCategory == data.name && (
					<Box sx={{ marginRight: '4px' }}>
						<CheckMark />
					</Box>
				)}
				<LencoTypography
					sx={{
						...getStyle('Small_Regular'),

						color:
							props.selectedCategory == data.name
								? getColor('')
								: getColor('Gray -2'),
					}}
				>
					{data.label}
				</LencoTypography>
			</FlexBox>
		</Link>
	);
}

export default CategoryTiles;
